import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import { Context } from "../contexts/AppContext";
import { getData, putData } from "../../lib/utils";
import { useNavigate, useParams } from "react-router-dom";
import VideoThumbnailExtractor from "../PropertyList/VideoThumbnailExtractor";

function AddMediaModal() {
  const navigate = useNavigate();
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [modalOpen, setModalOpen] = useState(appState.modalData);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const { galleryId } = useParams();

  Modal.setAppElement("#root");

    const formatDate = (isoString) => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const day = date.getDate();
    const month = date.toLocaleString("en-GB", { month: "short" });
    const hours = date.getHours() % 12 || 12;
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";
    return `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
  };

 useEffect(() => {
  const fetchData = async () => {
    const json = await getData(`galleries/get-gallery-videos/${galleryId}`, {});
    if (json) {
      setAppState((prevState) => ({
        ...prevState,
        videoArr: json.videos,
      }));

      // ✅ Only pre-select for selectedVideos, NOT for videoBg
      if (
        appState?.modalData?.openFrom !== "videoBg" &&
        appState?.currentGalleryData?.selectedVideos?.length > 0
      ) {
        const preSelected = json.videos
          .map((video, index) =>
            appState.currentGalleryData.selectedVideos.includes(video._id)
              ? index
              : null
          )
          .filter((i) => i !== null);

        setSelectedIndices(preSelected);
      } else {
        setSelectedIndices([]); // background modal ke liye reset selection
      }
    }
  };
  fetchData();
}, [galleryId, appState.modalData?.openFrom]);


  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      height: "100%",
      maxWidth: "100%",
      width: "100%",
      overflow: "hidden",
      border: "1px solid #00bcd4",
      borderRadius: "10px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
  };

  const addToLinkMediaHandler = async () => {
    if (appState.modalData.openFrom === "videoBg") {
      const videoUrl = `${appState?.videoArr[selectedIndices[0]]?.url}`;
      const json = await putData(`galleries/gallery/${galleryId}/background`, {
        videoUrl: videoUrl,
      });
      if (json) {
        setAppState((prevState) => ({
          ...prevState,
          backgroundMedia: {
            ...prevState.backgroundMedia,
            videoUrl: json.backgroundMedia?.videoUrl,
          },
        }));
        closeModal();
        window.location.reload();
      }
    } else {
      const selectedVideos = selectedIndices.map(
        (index) => appState.videoArr[index]._id
      );

      const json = await putData(
        `galleries/gallery/${galleryId}/selected-videos`,
        {
          selectedVideoIds: selectedVideos,
        }
      );
      if (json) {
        setAppState((prevState) => ({
          ...prevState,
          currentGalleryData: {
            ...(prevState.currentGalleryData || {}),
            selectedVideos: json.selectedVideos,
          },
        }));

        closeModal();
        window.location.reload();
      }
    }
  };

  const closeModal = () => {
    setAppState((prevState) => ({
      ...prevState,
      modalData: { ...prevState.modalData, type: null, isOpen: false },
    }));
  };

  const goBackHandler = () => {
    console.log("CLOSE MODAL wait ")
    closeModal();
  };

  return (
    <Modal
      isOpen={modalOpen.isOpen}
      onRequestClose={closeModal}
      style={customStyles}
    >
      <div>
        {/* Header Section */}
        <div className="flex justify-between">
          <div className="flex gap-4 justify-center items-center">
            <button
              onClick={goBackHandler}
              className="relative overflow-hidden px-4 py-2 text-white bg-gray-800 rounded-md hover:bg-gray-700 active:scale-95 transition duration-300 ease-in-out shadow-md"
            >
              Go Back
            </button>
            <div className="text-lg font-semibold mb-3 md:mb-0">
              Select Media
            </div>
          </div>
          <div>
            <button
              disabled={selectedIndices.length === 0}
              className={`relative overflow-hidden px-4 py-2 rounded-md transition duration-300 ease-in-out shadow-md ${
                selectedIndices.length === 0
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                  : "bg-gray-800 text-white hover:bg-gray-700 active:scale-95"
              }`}
              onClick={addToLinkMediaHandler}
            >
              Add to Show Case
            </button>
          </div>
        </div>

        {/* Image Grid */}
        <div
          id="grid"
          className="w-full flex justify-start mt-10 gap-4 flex-wrap h-[calc(100vh-180px)] overflow-auto"
        >
          {console.log("Arrray ",appState?.videoArr)}
          {Array.isArray(appState?.videoArr) && appState.videoArr.length > 0 ? (
            appState.videoArr.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  if (appState.modalData.openFrom === "videoBg") {
                    setSelectedIndices([index]); // only one select allowed
                  } else {
                    if (selectedIndices.includes(index)) {
                      setSelectedIndices(
                        selectedIndices.filter((i) => i !== index)
                      );
                    } else {
                      setSelectedIndices([...selectedIndices, index]);
                    }
                  }
                }}
                className={`relative  w-[30%] max-h-[250px] min-w-[300px] flex flex-col justify-center cursor-pointer transition duration-300 ${
                  selectedIndices.includes(index)
                    ? "bg-yellow-800"
                    : "bg-gray-200"
                } p-2 rounded-lg`}
              >
                <div className=" absolute  bottom-4 left-0 right-0 px-4 flex flex-col justify-between text-white font-medium text-left">
                <div>{item.title}</div>
                <div>{formatDate(item.createdAt)}</div>
                </div>
                
                    <img
 
                src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item.thumbnail}`}
                alt="thumbnail"
                className="w-full h-full object-cover rounded-lg"
                loading="lazy"
                onError={(e) => {
                 e.currentTarget.style.display = "none";
             

                
                }}
              />

                 
              </div>
            ))
          ) : (
            <div className="text-center text-gray-500 mt-4">
              No videos found.
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default AddMediaModal;
